<template>
  <div class="form-control w-full">
    <slot>
      <label class="label pb-3 pt-1">
        <span
          class="label-text pl-2"
          :class="tooltip ? 'tooltip' : ''"
          :data-tip="tooltip ?? ''"
        >
          {{ title ?? "List" }}
        </span>
      </label>
    </slot>

    <div class="w-full flex flex-wrap justify-start items-center gap-1">
      <TransitionGroup>
        <div
          ref="buttons"
          v-for="(entry, id) in entries"
          :key="id"
          @mouseover="hoverEntry = id"
          @mouseleave="hoverEntry = null"
          class="relative inline-block"
        >
          <button
            @click="$emit('select', id)"
            type="button"
            :class="[
              'btn btn-neutral btn-circle btn-sm h-9 w-9 no-animation',
              id == current
                ? ''
                : 'btn-outline text-neutral hover:border-neutral hover:bg-neutral',
              'transition-[filter] transition-transform ease-in-out duration-500',
              isHighlighted && isHighlighted(id) ? 'invert scale-125' : '',
            ]"
          >
            {{ entry }}
          </button>
          <div
            v-show="hoverEntry == id && !noDelete"
            class="absolute left-0 pt-1 z-10"
          >
            <button
              class="btn btn-circle btn-sm btn-outline h-9 w-9 text-neutral bg-base-100 hover:border-neutral hover:bg-neutral"
              @click="$emit('delete', id)"
            >
              <Icon icon="ic:baseline-delete" @mouseout.stop />
            </button>
          </div>
        </div>

        <button
          v-show="!noInsert"
          key="__add_button__"
          class="btn btn-circle btn-sm btn-outline h-9 w-9 text-neutral hover:border-neutral hover:bg-neutral"
          @click="$emit('insert', entries.length)"
        >
          <Icon icon="ic:baseline-add" class="hover:fill-neutral-content" />
        </button>
      </TransitionGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps<{
  entries: string[];
  current: number;
  title?: string;
  noInsert?: boolean;
  noDelete?: boolean;
  isHighlighted?: (id: number) => boolean;
  tooltip?: string;
}>();

defineEmits<{
  (_e: "select", _pos: number): void;
  (_e: "insert", _pos: number): void;
  (_e: "delete", _pos: number): void;
}>();

const hoverEntry = ref<number | null>(null);
const buttons = ref<HTMLElement[]>([]);

// const mouseOut = () => {
//   setTimeout(() => {
//     hoverEntry.value = null;
//   }, 200);
// };
</script>

<style scoped>
.v-move,
.v-enter-active,
.v-leave-active {
  transition: all 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: scale(0);
}
</style>
